import { Menu, MenuItem, Typography, useTheme } from '@mui/material';
import React from 'react';

import { colors } from '../../../components';

interface ExportDropdownMenuProps {
    anchorEl: HTMLElement | null;
    onClose: () => void;
    onSelectFormat: (format: 'CSV' | 'Excel' | 'PDF') => void;
    ariaLabel: string;
}

export const ExportDropdownMenu: React.FC<ExportDropdownMenuProps> = ({
    anchorEl,
    onClose,
    onSelectFormat,
    ariaLabel,
}) => {
    const theme = useTheme();

    return (
        <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            PaperProps={{
                role: 'region',
                'aria-label': ariaLabel,
                sx: {
                    bgcolor: colors.fullWhite,
                    mt: 1,
                    borderRadius: theme.spacing(1),
                    boxShadow: theme.shadows[2],
                    border: `1px solid ${colors.greyPreset[30]}`,
                    overflow: 'hidden',
                    '& .MuiList-root': {
                        gap: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        maxHeight: 130,
                        overflow: 'auto',
                    },
                    '& .MuiButtonBase-root': {
                        justifyContent: 'space-between',
                    },
                },
            }}
        >
            <MenuItem onClick={() => onSelectFormat('CSV')} sx={{ gap: 1 }}>
                <Typography variant="body2">CSV</Typography>
            </MenuItem>
            <MenuItem onClick={() => onSelectFormat('Excel')} sx={{ gap: 1 }}>
                <Typography variant="body2">Excel</Typography>
            </MenuItem>
            <MenuItem onClick={() => onSelectFormat('PDF')} sx={{ gap: 1 }}>
                <Typography variant="body2">PDF</Typography>
            </MenuItem>
        </Menu>
    );
};
